export default {
  adjustmentPeriods: [],
  adjustmentPeriod: null,
  adjustmentPeriodsLoading: false,
  companyCodes: [],
  companyCode: null,
  companyCodesLoading: false,
  connections: [],
  connection: null,
  connectionsLoading: false,
  companyCodesForConnection: [],
  companyCodeForConnection: null,
  beginningBalances: [],
  beginningBalancesLoading: false,
  importData: [],
  validationSummary: null,
  isUploadingBeginningBalances: false,
  ignoredCompanyCodes: [],
};
